// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Dl3U","left":"styles_left__3h2S-","right":"styles_right__3yMci","alert":"styles_alert__2KWei"};